import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { InputType } from "../../surveyTypes";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { SurveySectionContext } from "../SurveySection";

interface QuestionGroupHeaderProps {
  title: string;
}

const useGroupHeaderStyles = makeStyles((theme) => ({
  questionGroupHeader: { backgroundColor: "#e5e8ef" },
  titleCell: {
    width: "50%",
    padding: theme.spacing(2),
  },

  keyCell: {
    width: (keys: string[]) => `${50 / keys.length}%`,
    padding: theme.spacing(2),
  },
}));

const QuestionGroupHeaderDesktop: React.FC<QuestionGroupHeaderProps> = (
  props: QuestionGroupHeaderProps
) => {
  const { title } = props;
  const { keys, inputType } = React.useContext(SurveySectionContext);
  const classes = useGroupHeaderStyles(keys);

  return (
    <React.Fragment>
      <TableHead>
        <TableRow className={classes.questionGroupHeader}>
          <TableCell className={classes.titleCell}>
            <Typography variant="h6" component="h2">
              {title}
            </Typography>
          </TableCell>
          {inputType === InputType.RADIO &&
            keys.map((key, index) => (
              <TableCell key={index} className={classes.keyCell} align="center">
                <Typography variant="caption">{key}</Typography>
              </TableCell>
            ))}
          {inputType === InputType.SLIDER && (
            <TableCell>{keys.join(" ")}</TableCell>
          )}
        </TableRow>
      </TableHead>
    </React.Fragment>
  );
};

export default QuestionGroupHeaderDesktop;
